export default __webpack_public_path__ + "static/media/ico-about-24.658bc806.svg";